// extracted by mini-css-extract-plugin
export var breadcrumbs = "Footer-module--breadcrumbs--cd115";
export var contact = "Footer-module--contact--a4b04";
export var contactIcon = "Footer-module--contactIcon--98b12";
export var contactItem = "Footer-module--contactItem--4e22b";
export var contactTitle = "Footer-module--contactTitle--15450";
export var footer = "Footer-module--footer--519a5";
export var footerCopyright = "Footer-module--footerCopyright--c4755";
export var link = "Footer-module--link--5b8b3";
export var linkGroup = "Footer-module--linkGroup--97317";
export var linkGroupName = "Footer-module--linkGroupName--261ba";
export var logo = "Footer-module--logo--00312";
export var sitemap = "Footer-module--sitemap--69556";
export var socialLink = "Footer-module--socialLink--375f4";
export var socialLinks = "Footer-module--socialLinks--83a9b";